import React from "react";

const PageHero = ({ eyebrow, title, subtitle, image, imageStyle, disableZoomAnim }) => (
  <section className="relative h-[46vh] min-h-[360px] w-full overflow-hidden flex items-center">
    <img src={image} alt={title} style={imageStyle} className={`absolute inset-0 w-full h-full object-cover ${disableZoomAnim ? "" : "ken-burns"}`} />
    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/45 to-black/35" />
    <div className="relative max-w-[1240px] mx-auto px-5 md:px-8 w-full">
      <div className="max-w-[680px] fade-in">
        <p className="eyebrow !text-[#e6d3c6] mb-4">{eyebrow}</p>
        <h1 className="font-display font-light text-white text-[42px] md:text-[62px] leading-[1.04]">{title}</h1>
        {subtitle && (
          <p className="font-body text-white/85 text-[15px] md:text-[16px] leading-[1.9] mt-5 max-w-[560px]">{subtitle}</p>
        )}
      </div>
    </div>
  </section>
);

export default PageHero;
